import axios from 'axios';
import { API_DOCUMENT } from '../../constants/path';

const axiosDocument = axios.create({
    baseURL: API_DOCUMENT,
    headers: {
        'Content-type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': '*',
    },
});

// Add a request interceptor
axiosDocument.interceptors.request.use(
    function (config) {
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosDocument.interceptors.response.use(
    function (response) {
        return response.data;
    },
    function (error) {
        return Promise.reject(error);
    }
);


export default axiosDocument;


